import { useState } from "react";
import axios from "axios";
import ReactAudioPlayer from "react-audio-player";
import data from "../data.json";

export const Dictionary = () => {
  const [searchWord, setSearchWord] = useState(undefined);
  const [definitions, setDefinitions] = useState(null);
  const [photos, setPhotos] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const search = (event) => {
    event.preventDefault();
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${searchWord}`;
    axios
      .get(apiUrl)
      .catch(() => {
        setErrorMessage(
          "No definitions found. You can try the search again at later time or search another word instead."
        );
        setDefinitions(null);
      })
      .then((response) => {
        setDefinitions(response.data[0]);
      });

    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${searchWord}&per_page=9`;
    axios
      .get(pexelsApiUrl, {
        headers: {
          Authorization: data.apiKey,
        },
      })
      .then((response) => setPhotos(response.data.photos));
  };

  return (
    <span className="container">
      <section>
        <form onSubmit={search}>
          <input
            type="text"
            className="form-control"
            placeholder={"Enter a word"}
            value={searchWord}
            onChange={(e) => setSearchWord(e.target.value)}
            aria-label="Text input"
          />
        </form>
      </section>
      {errorMessage && <section>{errorMessage}</section>}
      {definitions && (
        <>
          <section>
            <h1 className="text-capitalize">{definitions.word}</h1>
            {definitions.phonetics.map((phonetic, index) => (
              <div key={index}>
                <p>{phonetic.text}</p>
                <ReactAudioPlayer
                  src={phonetic.audio}
                  controls
                  className="audioPlayer"
                />
              </div>
            ))}
          </section>
          {definitions.meanings.map((meaning, index) => (
            <div key={index}>
              <section>
                <h4>{meaning.partOfSpeech}</h4>
                {meaning.definitions.map((definitions, index) => {
                  return (
                    <div key={index}>
                      <div>{definitions.definition}</div>
                      {definitions.example && (
                        <div className="example">
                          <em>"{definitions.example}"</em>
                          <br />
                        </div>
                      )}
                      <br />
                      {definitions.synonyms.length > 0 && (
                        <div className="synonyms">
                          Similar :{" "}
                          {definitions.synonyms.map(function (synomyns, index) {
                            return (
                              <button
                                key={index}
                                name={synomyns}
                                value={synomyns}
                                className="similar"
                                onClick={search}
                                onMouseOver={(e) =>
                                  setSearchWord(e.target.value)
                                }
                                onMouseLeave={() => setSearchWord("")}
                              >
                                {synomyns}{" "}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </section>
            </div>
          ))}
        </>
      )}
      {photos && photos.length > 0 && (
        <section className="photos">
          <div className="row">
            {photos.map(function (photos, index) {
              return (
                <a
                  key={index}
                  href={photos.src.original}
                  target="_blank"
                  rel="noreferrer"
                  className="col-lg-4 col-sm-12 col-md-6"
                >
                  <img
                    alt={searchWord}
                    src={photos.src.tiny}
                    className="img-keyword"
                  />
                </a>
              );
            })}
          </div>
        </section>
      )}
      <footer>
        Coded by{" "}
        <a href="https://github.com/J-ustine" target="_blank" rel="noreferrer">
          Justine Collache
        </a>
      </footer>
    </span>
  );
};
